exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".confirm_container{display:none;position:fixed;left:0;top:0;width:100%;height:100%;z-index:125}.confirm_container.is-visible{display:block}", "", {"version":3,"sources":["/divvit-app/client/containers/ConfirmContainer/client/containers/ConfirmContainer/style.styl","/divvit-app/client/containers/ConfirmContainer/style.styl"],"names":[],"mappings":"AAAA,mBACE,aAAA,eACA,OACA,MACA,WACA,YACA,WACA,CAEA,8BACE,aAAA,CCCH","file":"style.styl","sourcesContent":[".confirm_container\n  display: none\n  position: fixed\n  left: 0\n  top: 0\n  width: 100%\n  height: 100%\n  z-index: confirm-z-index\n\n  &.is-visible\n    display: block\n",".confirm_container {\n  display: none;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 125;\n}\n.confirm_container.is-visible {\n  display: block;\n}\n/*# sourceMappingURL=client/containers/ConfirmContainer/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/containers/ConfirmContainer/style.styl
// module id = 479
// module chunks = 0